<template>
  <ValidationProvider v-slot="{ errors }" :rules="rules" :mode="mode">
    <component :is="groupIs" :class="classNames">
      <div class="form-group-content">
        <legend v-if="legend" class="form-group-label">
          {{ legend }}
          <abbr v-if="required" :title="$t('common.required')">*</abbr>
        </legend>
        <label v-else-if="label" :for="id" class="form-group-label">
          {{ label }}
          <abbr v-if="required" :title="$t('common.required')">*</abbr>
        </label>

        <div class="form-group-fields">
          <slot></slot>
        </div>
      </div>

      <div v-if="help || (errors && errors.length)" class="form-group-aside">
        <slot name="help">
          <div v-if="help" class="form-group-help">
            {{ help }}
          </div>
        </slot>

        <div v-if="errors && errors.length" class="form-group-errors">
          {{ errors[0] }}
        </div>
      </div>
    </component>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    ValidationProvider,
  },

  props: {
    row: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: null,
    },
    legend: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    help: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: [String, Object],
      default: null,
    },
    mode: {
      type: String,
      default: 'eager',
    },
  },

  computed: {
    groupIs() {
      return this.legend ? 'fieldset' : 'div';
    },

    classNames() {
      return ['form-group', { 'form-group--row': this.row }];
    },
  },
};
</script>

<style lang="scss">
$label-min-width: 150px;

.form-group {
  margin: 0;
  padding: 0;

  border: 0;

  &:not(.form-group--row) {
    .form-group-label {
      margin-bottom: $spacing-unit-tiny;
    }
  }
}

.form-group-content {
  .form-group--row & {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}

.form-group-label {
  min-width: $label-min-width;
  display: inline-block;

  color: $alt-700;

  abbr[title] {
    text-decoration: none;
  }
}

.form-group-fields {
  flex: 1;
}

.form-group-aside {
  margin-top: $spacing-unit-tiny;

  font-size: $font-size-small;
  color: $alt-600;

  .form-group--row & {
    padding-left: $label-min-width;
  }
}

.form-group-errors {
  font-weight: bold;
  color: $danger-500;
}
</style>
